"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _user = require("@/api/iot/user");
var _user2 = require("@/api/user");
var _status = require("@/api/iot/status");
var _battery = require("@/api/iot/battery");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _merchant = require("@/api/merchant");
var _batteryType = require("@/api/iot/batteryType");
var _authInfoDialog = _interopRequireDefault(require("@/components/dialogs/authInfoDialog"));
var _bindBatteryDialog = _interopRequireDefault(require("./dialog/bindBatteryDialog"));
var _userCouponDialog = _interopRequireDefault(require("./dialog/userCouponDialog"));
var _changeRentDialog = _interopRequireDefault(require("./dialog/changeRentDialog"));
var _changeDepositDialog = _interopRequireDefault(require("./dialog/changeDepositDialog"));
var _default = {
  components: {
    customPage: _customPage.default,
    bindBatteryDialog: _bindBatteryDialog.default,
    userCouponDialog: _userCouponDialog.default,
    changeRentDialog: _changeRentDialog.default,
    changeDepositDialog: _changeDepositDialog.default,
    authInfoDialog: _authInfoDialog.default
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        merchant_id: '',
        battery_no: '',
        user_name: '',
        mobile: '',
        status: '',
        freeze_status: '',
        lock_status: '',
        is_cert: '',
        bindDate: '',
        sort: ''
      },
      total: 0,
      tableData: [],
      rentStatusList: [],
      freezeStatusList: [],
      batteryTypeList: [],
      merchantList: [],
      lockStatusList: [],
      userCertStatusList: [],
      editItem: null,
      sortList: [{
        id: 1,
        label: '从大到小',
        value: 1
      }, {
        id: 2,
        label: '从小到大',
        value: 2
      }]
    };
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getBatteryTypeList();
    this.getUserRentStatusList();
    this.getUserCertStatusList();
    this.getUserRentFreezeStatusList();
    this.getLockStatusList();
    this.loadQuery();
    this.getList();
  },
  methods: {
    // 跳转订单详情
    jumpOrderDetail: function jumpOrderDetail() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$router.push({
        name: 'iotOrderUserOrder',
        query: {
          user_name: item.cert_name
        }
      });
    },
    loadQuery: function loadQuery() {
      var query = this.$route.query;
      for (var key in this.searchForm) {
        if (query[key]) {
          this.searchForm[key] = query[key];
        }
      }
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getBatteryTypeList: function () {
      var _getBatteryTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _batteryType.batteryTypeList)();
              case 2:
                res = _context2.sent;
                console.log('getBatteryTypeList', res);
                if (res) {
                  this.batteryTypeList = res.data;
                }
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getBatteryTypeList() {
        return _getBatteryTypeList.apply(this, arguments);
      }
      return getBatteryTypeList;
    }(),
    getLockStatusList: function () {
      var _getLockStatusList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _status.getLockStatusList)();
              case 2:
                res = _context3.sent;
                if (res) {
                  this.lockStatusList = res;
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getLockStatusList() {
        return _getLockStatusList2.apply(this, arguments);
      }
      return getLockStatusList;
    }(),
    getUserRentStatusList: function getUserRentStatusList() {
      var _this = this;
      (0, _status.getUserRentStatusList)().then(function (res) {
        // console.log('getUserRentStatusList', res)
        if (res) {
          _this.rentStatusList = res || [];
        }
      });
    },
    getUserCertStatusList: function getUserCertStatusList() {
      var _this2 = this;
      (0, _status.getUserCertStatusList)().then(function (res) {
        // console.log('getUserCertStatusList', res)
        if (res) {
          _this2.userCertStatusList = res || [];
        }
      });
    },
    getUserRentFreezeStatusList: function getUserRentFreezeStatusList() {
      var _this3 = this;
      (0, _status.getUserRentFreezeStatusList)().then(function (res) {
        // console.log('getUserRentFreezeStatusList', res)
        if (res) {
          _this3.freezeStatusList = res || [];
        }
      });
    },
    getList: function getList(flag) {
      var _this4 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _user.getUserRentList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this4.loading = false;
        _this4.tableData = res.data || [];
        _this4.total = res.total;
      });
    },
    // 排序
    handleSort: function handleSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sort = '';
      if (order) {
        this.searchForm.sort = [prop, order == 'ascending' ? 'asc' : 'desc'];
      }
      this.getList(true);
    },
    /**
     * 1 同意冻结，2 拒绝冻结
     **/
    handleFreeze: function () {
      var _handleFreeze = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(row, type) {
        var params, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('row', row);
                _context4.prev = 1;
                params = {
                  type: type,
                  id: row.id
                };
                _context4.next = 5;
                return (0, _user.freezeSave)(params);
              case 5:
                res = _context4.sent;
                console.log('res', res);
                _context4.next = 11;
                break;
              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);
              case 11:
                _context4.prev = 11;
                this.getList();
                return _context4.finish(11);
              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 9, 11, 14]]);
      }));
      function handleFreeze(_x, _x2) {
        return _handleFreeze.apply(this, arguments);
      }
      return handleFreeze;
    }(),
    getTagType: function getTagType(status) {
      if (status === 0) {
        return 'info'; // Use 'info' tag type for '未申请冻结'
      } else if (status === 1) {
        return 'warning'; // Use 'warning' tag type for '已申请冻结'
      } else if (status === 2) {
        return 'success'; // Use 'success' tag type for '同意冻结'
      } else if (status === 3) {
        return 'danger'; // Use 'danger' tag type for '拒绝冻结'
      }

      return ''; // Default to empty tag type
    },
    // 检测锁定状态
    chkLockStatusType: function chkLockStatusType(status) {
      var type = 'success';
      if (status == 1) {
        type = 'danger';
      }
      return type;
    },
    // 用户认证信息
    openAuthInfoDialog: function openAuthInfoDialog(val) {
      this.editItem = val || null;
      this.$refs.authInfoDialog.dialogVisible = true;
    },
    // 查看合同
    getEsignContract: function getEsignContract(item) {
      var _this5 = this;
      this.loading = true;
      (0, _user.getEsignContract)({
        flow_id: item.esign_flow_id
      }).then(function (res) {
        // console.log('getEsignContract', res)
        // console.log('res.files.downloadUrl', res.files[0].downloadUrl)
        _this5.loading = false;
        if (res) {
          window.open(res.files[0].downloadUrl);
        }
      }).catch(function (err) {
        return _this5.loading = false;
      });
    },
    // 检测状态
    chkStatusType: function chkStatusType(status) {
      var type = '';
      if (status == 1) {
        type = 'primary';
      } else if (status == 20) {
        type = 'success';
      } else if (status >= 40 && status <= 41) {
        type = 'danger';
      }
      return type;
    },
    // 检测实名状态
    chkUserCertStatusType: function chkUserCertStatusType(status) {
      var type = 'info';
      if (status == 1) {
        type = 'warning';
      } else if (status == 2) {
        type = 'success';
      }
      return type;
    },
    // 查看优惠券
    showUserCouponList: function showUserCouponList(item) {
      // console.log('showCouponUserList', item)
      this.editItem = item || null;
      this.$refs.userCouponDialog.dialogVisible = true;
    },
    // 绑定电池
    bindBattery: function bindBattery(item) {
      // console.log('bindBattery', item)
      this.editItem = item || null;
      this.$refs.bindBatteryDialog.dialogVisible = true;
    },
    // 归还电池
    returnBattery: function returnBattery(item) {
      var _this6 = this;
      this.$confirm('您确定要手动归还电池吗?', '归还电池', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        console.log('item.battery_id', item.battery_id);
        (0, _user.returnBattery)({
          user_rent_id: item.id,
          battery_id: item.battery_id
        }).then(function (res) {
          // console.log('returnBattery', res)
          _this6.getList(true);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    lockBattery: function lockBattery(item) {
      var _this7 = this;
      var lock_status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      console.log('item', item);
      var title = lock_status ? '锁定' : '解锁';
      this.$confirm("\u60A8\u786E\u5B9A\u8981".concat(title, "\u7535\u6C60\u5417?"), "".concat(title, "\u7535\u6C60"), {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        console.log('item.battery_id', item.battery_id);
        (0, _battery.batterySave)({
          id: item.battery_id,
          battery_type_id: item.battery_type_id,
          lock_status: lock_status
        }).then(function (res) {
          // console.log('lockBattery', res)
          _this7.getList(true);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    // 修改租期
    openChangeRentDialog: function openChangeRentDialog(item) {
      // console.log('openChangeRentDialog', item)
      this.editItem = item || null;
      this.$refs.changeRentDialog.dialogVisible = true;
    },
    // 修改需付押金
    openChangeDepositDialog: function openChangeDepositDialog(item) {
      // console.log('openChangeRentDialog', item)
      this.editItem = item || null;
      this.$refs.changeDepositDialog.dialogVisible = true;
    },
    // 退租
    surrenderOrder: function surrenderOrder(item) {
      this.$confirm('您确定要退租吗?', '退租', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 删除
    // removeItem(item) {
    //     this.$confirm('您确定要删除吗?', '删除', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //     })
    //         .then(() => {
    //             // delUser(item.id).then((res) => {
    //             //     this.getList(true)
    //             // })
    //         })
    //         .catch(() => {})
    // },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 跳转到电池
    jumpBattery: function jumpBattery() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$h5.href({
        name: 'chkgBattery',
        query: {
          battery_no: item.battery_no
        }
      }, 1);
    },
    // 跳转到换电记录
    jumpExchangeRecord: function jumpExchangeRecord() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$h5.href({
        name: 'iotOrderExchangeRecord',
        query: {
          cert_name: item.cert_name
        }
      }, 1);
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.$refs.table.clearSort();
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    },
    //强制跳过合同
    compulsioncontract: function compulsioncontract(row) {
      var _this8 = this;
      this.$confirm('此操作将使该用户跳过合同签署, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _user2.compulsionMemberUsercontract)({
          id: row.uid
        }).then(function () {
          _this8.getList();
        });
      });
    }
  }
};
exports.default = _default;